// src/App.tsx

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NotificacaoProvider } from "./context/NotificacaoContext";

import LoginPage from "./LoginPage";
import Subscription from "./pages/Subscription"; // Added import for RegisterPage
import AppLayout from "./AppLayout";
import { ThemeContextProvider } from "./components/theme/ThemeContext";
import Diretrizes from "./pages/Diretrizes";
import AmbienteExterno from "./components/ambiente-externo/AmbienteExterno";
import AmbienteInterno from "./pages/AmbienteInterno";
import MetasGlobais from "./pages/MetaGlobal";
import PlanoDeAcao from "./pages/PlanoDeAcao";
// import Avaliacao from "./pages/⁠Avaliacao";
import LandingPage from "./pages/LandingPage";
// import Convite from "../types/negocio/Convite";
// import SelecaoEmpresa from "./SelecaoEmpresa";
import Swot from "./pages/Swot";
import Profile from './pages/Profile';
import Notificacoes from './pages/Notificacoes';
import DemoAutoLogin from './pages/DemoAutoLogin';
import PitchDeck from './pages/PitchDeck';

// Components
import Desdobramento from "./pages/Desdobramento";
import Colaboradores from "./pages/Colaboradores";
import Dashboard from "./pages/Dashboard";

const App: React.FC = () => {
  // const [isConviteSelecionado, setIsConviteSelecionado] = useState<Convite>();

  // useEffect(() => {
  //   const conviteSelecionado = localStorage.getItem("conviteSelecionado") ? JSON.parse(localStorage.getItem("conviteSelecionado") as string) : null;
  //   setIsConviteSelecionado(conviteSelecionado);
  // }, []);

  // Define the AppContent component that uses the auth hooks
  const AppContent = () => {
    const { loading, signed } = useAuth();

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/tw/login" element={<LoginPage />} />
        <Route path="/tw/demo-login" element={<DemoAutoLogin />} />
        <Route path="/tw/register" element={<Subscription />} /> {/* Added register route */}
        <Route path="/tw/pitch" element={<PitchDeck />} /> {/* Pitch Deck route */}
        {/* <Route path="/tw/signup" element={<Signup />} />
        <Route path="/tw/confirm-email" element={<EmailConfirmation />} /> */}

        {/* Protected routes */}
        <Route
          path="/tw"
          element={
            signed ? (
              <AppLayout isAuthenticated={signed} />
            ) : (
              <Navigate to="/tw/login" />
            )
          }
        >
          {/* <Route path="empresa" element={<SelecaoEmpresa />} /> */}

          <Route path="dashboard" element={<Dashboard />} />
          <Route path="diretrizes" element={<Diretrizes />} />
          <Route path="colaboradores" element={<Colaboradores />} />
          <Route path="ambiente-externo" element={<AmbienteExterno />} />
          <Route path="ambiente-interno" element={<AmbienteInterno />} />
          <Route path="metas-globais" element={<MetasGlobais />} />
          <Route path="plano-de-acao" element={<PlanoDeAcao />} />
          <Route path="swot" element={<Swot />} />
          <Route path="desdobramento" element={<Desdobramento />} />
          <Route path="profile" element={<Profile />} />
          <Route path="notificacoes" element={<Notificacoes />} />
          {/* <Route path="avaliacao" element={<Avaliacao />} /> */}
          {/* <Route path="relatorios" element={<Relatorios />} /> */}
        </Route>
      </Routes>
    );
  };

  return (
    <ThemeContextProvider>
      {/* Removido o ThemeProvider duplicado */}
      <Router>
        <AuthProvider>
          <NotificacaoProvider>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                style={{ zIndex: 9999 }}
              />
              <AppContent />
            </NotificacaoProvider>
        </AuthProvider>
      </Router>
    </ThemeContextProvider>
  );
};

export default App;